import ShimmerSkeleton from "./ShimmerSkeleton";

export default ShimmerSkeleton;
